import React, { cloneElement } from 'react';
import { Box } from '@mui/material';
import { usePermissions } from '@hooks';

const PermissionsGate = ({
  children,
  RenderError = () => <Box />,
  errorProps = null,
  disabled = false,
  entity = null,
  width = null,
  height = null,
}) => {
  const { permissions } = usePermissions();
  let permissionGranted = true;
  if (!disabled && (!!entity || entity === 0)) {
    permissionGranted = permissions?.includes(entity);
  }
  if (!permissionGranted && !errorProps) return <RenderError />;

  if (!permissionGranted && errorProps)
    return cloneElement(children, { ...errorProps });

  return (
    <Box
      sx={{
        width,
        height,
      }}
    >
      {children}
    </Box>
  );
};

const memoizedPermissionsGate = React.memo(PermissionsGate);
export { memoizedPermissionsGate as PermissionsGate };
export default memoizedPermissionsGate;
